import styled from '@emotion/styled';
import { Icon, tokens, getInputContainerStyles } from '@hotjar/hotsauce';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { Site } from '@hotjar/navigation/src/types';

interface SelectedSiteProps {
  className?: string;
  site: Site | null;
}

const StyledContainer = styled.button`
  ${getInputContainerStyles({
    isInvalid: false,
    isDisabled: false,
    isReadonly: false,
  })};
  border: none;
  display: flex;
  align-items: center;
  gap: ${tokens.spacer.x1};
  width: auto;
  min-width: 0;
  max-width: 220px;
  height: ${tokens.spacer.x5};
  padding: 0 ${tokens.spacer.x2};

  ${tokens.elevation(0)};
  padding: 0 ${tokens.spacer.x1pt5};

  &:hover {
    ${tokens.elevation(0)};
    background-color: ${tokens.color.bg_hover};
  }

  &:focus-within {
    ${tokens.focus()}
  }
`;

const SiteName = styled.span`
  ${tokens.truncateText};
  flex-grow: 1;
  text-align: left;
`;

export const SelectedSite = forwardRef<HTMLButtonElement, SelectedSiteProps>(
  ({ className, site }: SelectedSiteProps, ref): JSX.Element => {
    const { t } = useTranslation('navigation');

    return (
      <StyledContainer ref={ref} className={className}>
        <SiteName>{site?.name ?? t('SiteSelector.noSiteSelected')}</SiteName>
        <Icon icon="caret_down_alt" size="m" color="text_disabled" />
      </StyledContainer>
    );
  },
);

SelectedSite.displayName = 'SelectedSite';
